module.exports = require("./mer.d.ts");